import { BaseController } from '../../../base/controller';

export class FormButtonsController extends BaseController {
  constructor(controllerService, $transclude) {
    'ngInject';
    super({ controllerService, $transclude });
  }

  $onInit() {
    // Set col size which depends on whether
    // the center content has been given.
    let colSize = 4;
    if (!this.transcludePresent('center')) {
      colSize = 6;
    }

    this.leftColSize = `col-sm-${this.leftCol || colSize}`;
    this.centerColSize = `col-sm-${this.centerCol || colSize}`;
    this.rightColSize = `col-sm-${this.rightCol || colSize}`;
  }

  transcludePresent(slot) {
    return this.$transclude.isSlotFilled(slot);
  }
}
